/**
 * Raw SVG markup for Google Maps marker pins.
 * These are encoded into data-URIs at runtime because the Maps JS API
 * requires a URL (not a React component) for custom marker icons.
 */

/** Solid green pin — used for unselected map markers. */
const PIN_SVG_DEFAULT = `<svg xmlns="http://www.w3.org/2000/svg" width="35" height="48" viewBox="0 0 34.781 48"><g transform="translate(0.121)"><rect width="34.66" height="48" fill="none"/><path d="M17.23,31a7.33,7.33,0,0,0,7.34-7.32h0a7.54,7.54,0,0,0-7.34-7.6,7.33,7.33,0,0,0-7.34,7.31h0A7.74,7.74,0,0,0,17.23,31ZM4.8,11.05A17.42,17.42,0,1,1,29.53,35.59l-.1.09L17.11,48,4.8,35.68a17.87,17.87,0,0,1,0-24.63Z" fill="#2C4F26"/></g></svg>`;

/** Outlined pin with light fill — used for the currently selected marker. */
const PIN_SVG_SELECTED = `<svg xmlns="http://www.w3.org/2000/svg" width="35" height="48" viewBox="-3 -3 40.781 54"><g transform="translate(0.121)"><rect width="34.66" height="48" fill="none"/><path d="M17.23,31a7.33,7.33,0,0,0,7.34-7.32h0a7.54,7.54,0,0,0-7.34-7.6,7.33,7.33,0,0,0-7.34,7.31h0A7.74,7.74,0,0,0,17.23,31ZM4.8,11.05A17.42,17.42,0,1,1,29.53,35.59l-.1.09L17.11,48,4.8,35.68a17.87,17.87,0,0,1,0-24.63Z" fill="#FAFFEE" stroke="#2C4F26" stroke-width="3"/></g></svg>`;

/** Returns a `data:image/svg+xml` URL for the appropriate pin variant. */
function pinUrl(selected: boolean): string {
  const svg = selected ? PIN_SVG_SELECTED : PIN_SVG_DEFAULT;
  return `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(svg)}`;
}

/** Pixel dimensions matching the SVG viewBox, used for `google.maps.Size`. */
const PIN_ICON_SIZE = { height: 48, width: 35 } as const;

/** Returns a full marker icon config ready for `google.maps.Marker` or `setIcon`. */
export function getMarkerIcon(selected: boolean): google.maps.Icon {
  return {
    scaledSize: new google.maps.Size(PIN_ICON_SIZE.width, PIN_ICON_SIZE.height),
    url: pinUrl(selected),
  };
}
